import withSSRModel from "hoc-lib/ssrModelMapper"
import { withAuthentication } from "hoc-lib/appAuthentication"
import { withSpacing } from "hoc-lib/spacing"

import ReviewCarousel from "./ReviewCarousel"

const WrappedComponent = withSSRModel(
  withAuthentication(
    withSpacing({ useRebrandedspacingColor: true })(ReviewCarousel),
  ),
)

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default WrappedComponent
